import { render, staticRenderFns } from "./ContractTypologyTable.vue?vue&type=template&id=748dc772&"
import script from "./ContractTypologyTable.vue?vue&type=script&lang=js&"
export * from "./ContractTypologyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports